import { render } from "./TagRelationTypeColumn.vue?vue&type=template&id=19394a7c&scoped=true"
import script from "./TagRelationTypeColumn.vue?vue&type=script&lang=js"
export * from "./TagRelationTypeColumn.vue?vue&type=script&lang=js"

import "./TagRelationTypeColumn.vue?vue&type=style&index=0&id=19394a7c&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19394a7c"]])

export default __exports__